import styled from "styled-components";
import { Alert } from "antd";

export const StyledAlert = styled(Alert)`
  font-size: 14px;
  padding: 18px;
  border-radius: 3px;
  justify-content: center;
  align-items: center;
  display: flex;
  max-width: ${(props: { width?: number, bottom?: number }) => props.width || 565}px;
  margin-left: auto;
  margin-right: auto;
  position: fixed;
  bottom: ${(props: { bottom?: number }) => props.bottom || 57}px;
  width: 100%;
  z-index: 10001;
  animation: fadeOut 1s forwards;
  animation-delay: 3s;
  right: 0;
  left: 0;

  & .anticon {
    font-size: 20px;
  }
  & .ant-alert-content {
    flex: 0 1 auto;
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

export const AlertContainer = styled.div`
  display: flex;
  justify-content: center;
`;
